// RITA-1525 — Darstellung eines Blocks (Absatz, Liste, manueller Seitenumbruch).
// Jeder Block trägt data-block-id, damit Messung, Seitenansicht und Bearbeitung dieselben Höhen und
// Positionen sehen. Listeneinträge tragen data-eintrag. Der Seitenumbruch ist eine nicht editierbare
// Insel; in der Bearbeitung zeigt er einen Knopf zum Entfernen (Klick wird vom Editor ausgewertet).
import React from 'react';
import { Wertemodus } from '../model/platzhalterwerte';
import { Block } from '../model/types';
import InlineAnsicht from './InlineAnsicht';

interface Props {
  block: Block;
  modus: Wertemodus;
  /** In der Bearbeitung: Seitenumbrüche zeigen „entfernen“. */
  bearbeitbar?: boolean;
  gesperrt?: boolean;
}

function BlockAnsicht({ block, modus, bearbeitbar = false, gesperrt = false }: Props) {
  switch (block.typ) {
    case 'absatz':
      return (
        <p className="vertrag-absatz" data-block-id={block.id}>
          <InlineAnsicht inhalt={block.inhalt} modus={modus} />
        </p>
      );
    case 'liste':
      return (
        <ul className="vertrag-liste" data-block-id={block.id}>
          {block.eintraege.map((eintrag, index) => (
            // Listeneinträge haben keine eigene Kennung und werden in der Anzeige nie umsortiert.
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${block.id}-${index}`} data-eintrag={index}>
              <InlineAnsicht inhalt={eintrag} modus={modus} />
            </li>
          ))}
        </ul>
      );
    case 'seitenumbruch':
      return (
        <div
          className="vertrag-seitenumbruch"
          data-block-id={block.id}
          role="separator"
          aria-label="Manueller Seitenumbruch"
          contentEditable={false}
        >
          {bearbeitbar && (
            <button
              type="button"
              className="vertrag-seitenumbruch-entfernen"
              data-aktion="seitenumbruch-entfernen"
              data-umbruch-id={block.id}
              aria-label="Seitenumbruch entfernen"
              disabled={gesperrt}
            >
              Seitenumbruch entfernen ✕
            </button>
          )}
        </div>
      );
    default:
      return null;
  }
}

export default React.memo(BlockAnsicht);
